import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { setupPage } from "./utils/pageSetup";

// SEO metadata, structured data, non-blocking fonts and the LCP preload,
// applied before React renders.
setupPage();
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-193" data-mp="2677mr72xq6qk" />);
}